// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"_1N5g662VLoAZvys-ERRb2L","icon":"jm7Hion-1A9UV1LGt3zEw"};